// extracted by mini-css-extract-plugin
module.exports = {"container":"e3","image":"e4","title":"e5","desc":"e6"};